import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative group overflow-hidden rounded-xl font-bold text-lg px-8 py-4
        bg-gradient-to-r from-[#00d4ff] to-[#0088ff] text-white
        shadow-[0_0_20px_rgba(0,212,255,0.3)]
        hover:shadow-[0_0_30px_rgba(0,212,255,0.5)]
        transition-all duration-300
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-201">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-202" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-203">
        {children}
      </span>
    </motion.button>;
}